import React, { FC } from 'react'
import { usePastRewardRaffles, useRewardRaffles } from '../../techRaffles/hooks/raffle'
import { useParticipantDataForMultipleRaffles } from '../hooks/useParticipant'
import { VStack, SimpleGrid, Box, Text } from '@chakra-ui/react'
import CalloutBox from '../../../components/CalloutBox'
import RaffleCard from '../../dApp/components/RaffleCard'
import RaffleCardListSkeleton from '../../dApp/components/Skeletons/RaffleCardListSkeleton'
import RewardRaffleList from './RewardRaffleList'

const PastRewards: FC<{ userId?: string }> = ({ userId }) => {
  const rewardRaffleRes = usePastRewardRaffles(0)
  const rewardRaffles = rewardRaffleRes.data
  const rewardRafflesWithParticipantData = useParticipantDataForMultipleRaffles(
    { userId, raffles: rewardRaffles }
  )

  console.log({ userId, rewardRafflesWithParticipantData })

  return (
    <VStack w='full' mt='10' spacing='1rem'>
      <CalloutBox
        emoji='💎'
        infoText='These are all past rewards on Monet!'
      ></CalloutBox>
      <Text alignSelf='start'></Text>

      <RewardRaffleList
        rewardRaffles={rewardRafflesWithParticipantData ?? rewardRaffles ?? []}
        userId={userId}
        isLoading={rewardRaffleRes.isLoading}
      />
    </VStack>
  )
}

export default PastRewards
